/**
 * Utils
 */
var KKUtils = (function(){

    queryParams = function(){
        if (location.search.length) {
            for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                aKeyValue = aCouples[i].split('=');
                if (aKeyValue.length > 1) {
                    queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                }
            }
        }
    };

    const setCookie = function( timer, cookieName, value ) {
        var date = new Date();
        date.setTime( date.getTime() + (timer * 60 * 1000) );

        $.cookie(cookieName, value, {
            expires: date,
            path: '/'
        } );
    };

    /**
     * Get Product Object by its handle
     */
    const getProductObjByHandle = function ( handle ) {
        var url = '/products/' + handle + '.js';

        return JSON.parse(
            $.ajax({
                url: url,
                dataType: 'json',
                global: false,
                async: false,
                success: function (data) {
                    return data;
                }
            }).responseText
        );
    };

    return {
        queryParams:queryParams,
        setCookie:setCookie,
        getProductObjByHandle: getProductObjByHandle,
    }
})();

/**
 * UIs
 */
var KKUIs = (function(){

    const preloader = function(){
        $(window).on('load', function(){
            $(".spinner-border").fadeOut('slow');
        });
    };
  
    const mobileMenu = function(){
        $(".site-header__mobile-menu-toggler").click(function(){
            $(".mobile-menu-wrapper").addClass("active");
            $(".mobile-menu-overlay").addClass("active");
        });

        $(".mobile-menu-wrapper .close-box").click(function(){
            $(".mobile-menu-wrapper").removeClass("active");
            $(".mobile-menu-overlay").removeClass("active");
        });
    };  

    const headerSearch = function() {
        const opener = $(".js-search-link");
        const close = $(".js-search-close-link");

        if( opener.length ) {
            opener.on("click",function(e){
                e.preventDefault();
                $(".site-header__search-popup")
                    .addClass("util-opacity-1")
                    .removeClass("util-opacity-0");
                $('.site-header__search-popup input[type="search"]').focus();
            });
        }

        if( close.length ) {
            close.on("click",function(e){
                e.preventDefault();
                $(".site-header__search-popup")
                    .addClass("util-opacity-0")
                    .removeClass("util-opacity-1");
            });
        }
    };

    const goToTop = function(){
        const handler = $(".js-back-to-top");
        if( handler.length ) {

            handler.on("click",function(){
                $('body,html').animate({scrollTop: 0}, 800);
            });

            $(window).scroll(function(){
                if ($(this).scrollTop() > 300) {
                    handler.fadeIn('slow');
                } else {
                    handler.fadeOut('slow');
                }
            });
        }
    };
  
  	const stickyHeader = function() {
      const handler = $(".site-header-sticky");
      if( handler ) {
        $(window).scroll(function(){
          if ($(this).scrollTop() > 100) {
            handler.addClass("js-site-header-sticky-active");
          } else {
            handler.removeClass("js-site-header-sticky-active");
          }
      	});
      }
    };

    const updateCartItemCount = function() {
        const $cartIcon = $(".js-cart-link").find(".js-cart-item-count");
        const $parent   = $cartIcon.parents(".site-header__cart");

        if( $cartIcon.length ) {
            $.getJSON('/cart.js', function(cart){
                var count = cart.item_count;
                if( count > 0 ) {
                    $cartIcon.addClass("js-visible");
                    $parent.addClass("show-mini-cart");
                } else {
                    $cartIcon.removeClass("js-visible");
                    $parent.removeClass("show-mini-cart");
                }
                $cartIcon.html( count );
            });

            updateMiniCart();
        }
    };

    const updateMiniCart = function() {
        Shopify.getCart(function(cart){
            const cartContent = $('.js-mini-cart-content');
            const cartTotal   = $('.js-mini-cart-total');
            const empty       = '<div class="alert">'+kktheme.strings.cartEmpty+'</div>';
            var   cartHTML    = cart.item_count === 0 ? empty : '';

            cartTotal.html( Shopify.formatMoney( cart.total_price, kktheme.moneyFormat ) );
            KKUIs.updateCurrencies();

            for( var i = 0; i < cart.items.length; i++ ){
                var product      = cart.items[i],
                    productPrice = Shopify.formatMoney( product.price, kktheme.moneyFormat );

                cartHTML += '<div class="mini-cart-item">';
                    cartHTML += '<a class="mini-cart-image" href="'+product.url+'">';
                        if( product.image != null ) {
                          cartHTML += '<img src="'+ product.image +'"/>';  
                        } else {
                          cartHTML += '<img src="https://via.placeholder.com/300x300.png"/>';  
                        }
                    cartHTML += '</a>';
                    cartHTML += '<div class="mini-cart-meta">';
                        cartHTML += '<a class="mini-cart-product" href="'+product.url+'">';
                            cartHTML += product.title;
                        cartHTML += '</a>';
                        cartHTML += '<span class="mini-cart-product-price">'+ productPrice +'</span> x <span class="mini-cart-product-qty">'+product.quantity+'</span>';
                    cartHTML += '</div>';
                    cartHTML += '<a class="js-remove-mini-cart-item" href="javascript:void(0);" data-id="'+product.id+'">&times;</a>';
                cartHTML += '</div>';

                KKUIs.updateCurrencies();
            }

            cartContent.html( cartHTML );
        });
    };

    const removeItemFromMiniCart = function() {
        $(document).on("click",".js-remove-mini-cart-item",function(e){
            e.preventDefault();
            const id = $(this).attr("data-id");
            $(this).parent().fadeOut();
            Shopify.changeItem(id,0,updateMiniCart);

            setTimeout(function(){          
                const $cartIcon = $(".js-cart-link").find(".js-cart-item-count");
                if( $cartIcon.length ) {
                	$.getJSON('/cart.js', function(cart){
                		var count = cart.item_count;
                		$cartIcon.html( count );
                	});
                }
            }, 1000 );
        });
    };

    const passwordPageLoginForm = function() {
        const holder = $("#site-login-popup-modal");
        const opener = $(".js-modal-open-login-link");
        const close  = $(".js-modal-close-login-link");

        if( holder.length ) {

            if( opener.length ) {
                opener.on("click",function(e){
                    e.preventDefault();
                    holder
                        .addClass("util-opacity-1")
                        .removeClass("util-opacity-0");
                });
            }

            if( close.length ) {
                close.on("click",function(e){
                    e.preventDefault();                    
                    holder
                        .addClass("util-opacity-0")
                        .removeClass("util-opacity-1");
                });
            }
        }
    };

    const newsletterPopup = function() {

        const popup = $("#js-news-letter-popup");
        if( popup.length ) {
            const delay    = popup.attr("data-delay");
            const timer    = popup.attr("data-timer");
            const closeBtn = popup.find(".js-news-letter-close");

            if( Shopify.designMode === true ) {
                $(window).on('load',function(){
                    setTimeout(function(){
                        popup.modal( 'show' );
                    }, ( delay*1000 ) );
                });
            } else {
                const cookieName = 'kkNewsletterPopupCookies';

                if ($.cookie( cookieName ) !== "disabled") {

                    $(window).on('load',function(){
                        setTimeout(function(){
                            popup.modal( 'show' );
                        }, ( delay*1000 ) );
                    });

                    popup.on('hide.bs.modal', function(e){
                        KKUtils.setCookie( timer, cookieName, 'disabled' );
                    });

                    popup.find('form').submit( KKUtils.setCookie( timer, cookieName, 'disabled' ) );

                    closeBtn.on("click",function(){
                        popup.modal( 'hide' );
                    });
                }
            }

        }
    };

    const cookiePolicy = function() {
        const holder = $("#js-cookie-policy");
        if( holder.length ) {
            const done = localStorage.getItem('kkCookiePolicy') || '';
            const btn  = holder.find("#js-cookie-ok");

            if( done === '' ) {
                holder.fadeIn("slow");
            }

            btn.on("click",function(){
                localStorage.setItem('kkCookiePolicy', 'done');
                holder.fadeOut("slow");
            });
        }
    };

    const multiCurrencies = function() {
        var shopCurrency     = Shopify.currency.active;
        var cookieCurrency   = Currency.cookie.read();
        var currencySwitcher = jQuery('#js-multi-currencies');  // Select all your currencies buttons.

        Currency.format = 'money_format';

        // Fix for customer account pages
        jQuery('span.money span.money').each(function(){
            jQuery(this).parent('span.money').removeClass('money');
        });

        // Add precalculated shop currency to data attribute
        jQuery('span.money').each(function(){
            jQuery(this).attr('data-currency-' + Shopify.currency.active, jQuery(this).html());
        });

        // When the page loads.
        if (cookieCurrency == null || cookieCurrency == shopCurrency) {
            Currency.currentCurrency = shopCurrency;
        } else {
            Currency.currentCurrency = cookieCurrency;
            Currency.convertAll(shopCurrency, cookieCurrency);
            currencySwitcher.val(cookieCurrency);
        }

        currencySwitcher.change(function(){
            var newCurrency = jQuery(this).val();
            Currency.cookie.write(newCurrency);
            Currency.convertAll(Currency.currentCurrency, newCurrency);
            currencySwitcher.val(newCurrency);
        });
    };

    const updateCurrencies = function() {
        var currencySwitcher = jQuery('#js-multi-currencies');
        var shopCurrency     = Shopify.currency.active;
        Currency.convertAll(shopCurrency, currencySwitcher.val() );
    };

    const productCardAddToCart = function() {
        $(document).on("click", '.js-grid-btn-add-to-cart', function(){
            var $This  = $(this);
            var handle = $This.attr("data-handle");
            if( handle ) {
                $This.addClass("is-loading");
                Shopify.addItem( handle, 1, function(item){
                    KKUIs.updateCartItemCount();
                    setTimeout(function(){
                        $This.removeClass("is-loading");
                        $This.find('span.btn-text').text('Added to Cart');
                    }, 1000);
                });
            }
        });
    };

    return {
        init: function(){
            preloader();
          	mobileMenu();
            headerSearch();
            goToTop();
            stickyHeader();
            passwordPageLoginForm();
            newsletterPopup();
            cookiePolicy();

            multiCurrencies();
            updateCurrencies();
            productCardAddToCart();
            updateCartItemCount();

            removeItemFromMiniCart();
        },
        updateCartItemCount:updateCartItemCount,
        updateCurrencies:updateCurrencies,
        productCardAddToCart:productCardAddToCart
    };
})();

/**
 * Image Carousel
 */
var KKImageCarousel = (function(){
    const carousel = $(".js-section-image-carousel").find(".js-slick-carousel");

    const kkSlick = function( ele ) {
        var settings = {
            arrows: ele.data('arrows') || false,
            draggable: ele.data('draggable') || false,
            dots: ele.data('dots') || false,
            infinite: ele.data('infinite') || false,
            autoplay: ele.data('autoplay') || false,
            autoplaySpeed: ele.data('speed') || 3000,
            slidesToShow: ele.data('slidestoshow') || 1,
            slidesToScroll: ele.data('slidescroll') || 1,
            adaptiveHeight: true,
        };

        var responsive = [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: ( settings.slidesToShow - 1 ) > 1 ? ( settings.slidesToShow - 1 ) : 1,
                    slidesToScroll: ( settings.slidesToScroll - 1 ) > 1 ? ( settings.slidesToScroll - 1 ) : 1,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: ( settings.slidesToShow - 2 ) > 1 ? ( settings.slidesToShow - 2 ) : 1,
                    slidesToScroll: ( settings.slidesToScroll - 2 ) > 1 ? ( settings.slidesToScroll - 2 ) : 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: ( settings.slidesToShow - 3 ) > 1 ? ( settings.slidesToShow - 3 ) : 1,
                    slidesToScroll: ( settings.slidesToScroll - 3 ) > 1 ? ( settings.slidesToScroll - 3 ) : 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow:1,
                    slidesToScroll:( settings.slidesToScroll - 4 ) > 1 ? ( settings.slidesToScroll - 4 ) : 1,
                }
            }
        ];

        settings.responsive = responsive;

        ele.not('.slick-initialized').slick( settings );
    };

    return {
        init: function() {
            if( carousel.length ) {
                carousel.each(function(){
                    KKImageCarousel.kkSlick( $(this) );
                });
            }
        },
        kkSlick: kkSlick
    };
})();

/**
 * Slider 1
 */
var KKSlider1Carousel = (function(){
    const carousel = $(".js-section-slider").find(".js-section-slideshow");
    const kkSlick  = function( ele ) {
        var settings = {
            arrows: ele.data('arrows') || false,
            draggable:true,
            dots: ele.data('dots') || false,
            autoplay: ele.data('autoplay') || false,
            autoplaySpeed: ( ele.data('speed') * 1000 ) || 3000,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
        };

        ele.not('.slick-initialized').slick( settings );
    };

    return {
        init: function(){
            if( carousel.length ) {
                carousel.each(function(){
                    KKSlider1Carousel.kkSlick( $(this) );
                });
            }
        },
        kkSlick: kkSlick
    }
})();

/**
 * Featured Product Carousel
 */
var KKFeaturedProductCarousel = (function(){
    const carousel = $(".product-featured-section.js-product-featured-slick-slider");
    const kkSlick  = function( ele ) {
        var settings = {
            arrows: ele.data('arrows') || false,
            draggable: ele.data('draggable') || false,
            dots: ele.data('dots') || false,
            infinite: ele.data('infinite') || false,
            autoplay: ele.data('autoplay') || false,
            autoplaySpeed: ele.data('speed') || 3000,
            slidesToShow: ele.data('slidestoshow') || 1,
            slidesToScroll: ele.data('slidescroll') || 1,
            adaptiveHeight: true,
        };

        var responsive = [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: ele.data('slidestoshow') || 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow:1,
                    slidesToScroll:1,
                }
            }
        ];

        settings.responsive = responsive;

        ele.not('.slick-initialized').slick( settings );
    };

    return {
        init: function(){
            if( carousel.length ) {
                carousel.each(function(){
                    KKFeaturedProductCarousel.kkSlick( $(this) );
                });
            }
        },
        kkSlick: kkSlick
    };
})();

/**
 *  Testimonial 1 Carousel
 */
var KKTestimonial1Carousel = (function(){
    const carousel = $(".js-section-testimonial-1-carousel").find(".js-slick-carousel");
    const kkSlick  = function( ele ) {
        var settings = {
            arrows: ele.data('arrows') || false,
            draggable: ele.data('draggable') || false,
            dots: ele.data('dots') || false,
            infinite: ele.data('infinite') || false,
            autoplay: ele.data('autoplay') || false,
            autoplaySpeed: ele.data('speed') || 3000,
            slidesToShow: ele.data('slidestoshow') || 1,
            slidesToScroll: ele.data('slidescroll') || 1,
            adaptiveHeight: true,
        };

        ele.not('.slick-initialized').slick( settings );
    };

    return {
        init: function(){
            if( carousel.length ) {
                carousel.each(function(){
                    KKTestimonial1Carousel.kkSlick( $(this) );
                });
            }
        },
        kkSlick: kkSlick
    };
})();

/**
 * Testimonial 2 Carousel
 */
var KKTestimonial2Carousel = (function(){
    const carousel = $(".js-section-testimonial-2-carousel").find(".js-slick-carousel");
    const kkSlick  = function( ele ) {
        var settings = {
            arrows: ele.data('arrows') || false,
            draggable: ele.data('draggable') || false,
            dots: ele.data('dots') || false,
            infinite: ele.data('infinite') || false,
            autoplay: ele.data('autoplay') || false,
            autoplaySpeed: ele.data('speed') || 3000,
            slidesToShow: ele.data('slidestoshow') || 1,
            slidesToScroll: ele.data('slidescroll') || 1,
            adaptiveHeight: true,
        };

        var responsive = [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: ele.data('slidestoshow') || 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2 || 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: ele.data('md-col') || 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow:1,
                    slidesToScroll:1,
                }
            }
        ];

        settings.responsive = responsive;

        ele.not('.slick-initialized').slick( settings );
    };

    return {
        init: function(){
            if( carousel.length ) {
                carousel.each(function(){
                    KKTestimonial2Carousel.kkSlick( $(this) );
                });
            }
        },
        kkSlick: kkSlick
    };
})();

/**
 * Section: Video
 */
var KKVideoPopup = (function(){
    const section   = $(".js-section-video-popup");
    const kkModal = function( ele ) {
        const link = ele.find(".js-video-popup-link"),
            modal  = ele.find(".modal"),
            iframe = ele.find(".embed-responsive-item");

        const modalId = modal.attr("id");
        const video = link.attr("data-src");
      
        iframe.attr("src", video + "?autoplay=0&amp;modestbranding=1&amp;showinfo=0" );
        

        const modalIns = new bootstrap.Modal(document.getElementById( modalId ) );

        link.on("click",function(){
            modalIns.show();
        });

        $( "#"+modalId ).on('shown.bs.modal', function(e){
          iframe.attr("src", video + "?autoplay=0&amp;modestbranding=1&amp;showinfo=0" );
        });

        $( "#"+modalId ).on('hide.bs.modal', function(e){
          iframe.attr("src","");
        });
    };

    return {
        init: function(){
            if( section.length ){
                section.each(function(){
                    KKVideoPopup.kkModal( $(this) );
                });
            }
        },
        kkModal: kkModal
    };
})();

/**
 * Section: Custom Elements
 */
var KKCustomElements = (function(){
    const section = $(".js-section-custom-elements");

    const KKAnimateNumber = function( section ) {
        const number = section.find(".js-animate-number");

        number.each(function(){
            var field  = $(this).find(".number"),
                number = field.attr("data-number");
                prefix = field.attr("data-prefix");

            if( typeof prefix === "undefined" ) {
                var numberStep = $.animateNumber.numberStepFactories.separator(',', 3 );
            } else {
                var numberStep = $.animateNumber.numberStepFactories.separator(',', 3, prefix );
            }

            $(this).one('inview', function (event, visible) {
                if(visible === true) {
                    field.animateNumber({
                        number:number,
                        numberStep: numberStep
                    }, 1000 );
                }
            });
        });
    };

    return {
        init: function(){
            if( section.length ){
                section.each(function(){
                    KKCustomElements.KKAnimateNumber( $(this) );
                });
            }
        },
        KKAnimateNumber: KKAnimateNumber
    };
})();

/**
 * Section: Instagram
 */
var KKInstagrm = (function(){
    const container = $(".js-section-instagram").find(".js-instagram");
    const show = function(ele) {
        var id          = ele.attr("id");
        var style       = ele.data('style');
        var accesstoken = ele.data('accesstoken');
        var limit       = ele.data('limit');

        if ( style === 'grid' ) {
            var feed = new Instafeed({
                get        : 'user',
                target     : id,
                accessToken: accesstoken,
                limit      : limit,
                template   : '<div class="col"><a class="instagram-item" href="{{link}}" target="_blank" id="{{id}}"><img alt="instagram image" class="lazyload" data-src="{{image}}" /></a></div>',
            });
            feed.run();

        } else if ( style === 'carousel' ) {

            var settings = {
                arrows: ele.data('arrows') || false,
                draggable: ele.data('draggable') || false,
                dots: ele.data('dots') || false,
                infinite: ele.data('infinite') || false,
                autoplay: ele.data('autoplay') || false,
                autoplaySpeed: ele.data('speed') || 3000,
                slidesToShow: ele.data('slidestoshow') || 1,
                slidesToScroll: ele.data('slidescroll') || 1,
                adaptiveHeight: true,
            };

            var slidestoshow1200 = (settings.slidestoshow - 1) > 1? (settings.slidestoshow - 1) : 1;
            var slidestoshow992  = (settings.slidestoshow - 2) > 1? (settings.slidestoshow - 2) : 1;
            var slidestoshow768  = (settings.slidestoshow - 3) > 1? (settings.slidestoshow - 3) : 1;

            var responsive = [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: slidestoshow1200,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: slidestoshow992,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: slidestoshow768,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow:1,
                        slidesToScroll:1,
                    }
                }
            ];

            settings.responsive = responsive;

            var callback = function() {
                ele.not('.slick-initialized').slick( settings );
            };

            var feed = new Instafeed({
                get        : 'user',
                target     : id,
                accessToken: accesstoken,
                limit      : limit,
                template   : '<div class="col"><a class="instagram-item" href="{{link}}" target="_blank" id="{{id}}"><img alt="instagram image" class="lazyload" data-src="{{image}}" /></a></div>',
                after      : callback
            });

            feed.run();
        }
    };

    return {
        init: function(){
            if( container.length ) {
                container.each(function(){
                    KKInstagrm.show( $(this) );
                });
            }
        },
        show: show
    };
})();

/**
 * Template: Product
 */
var KKProductPage = (function(){

    const productJSON          = kktheme.product;
    const variantSelector      = $("body.template-product").find("#ProductSelect");
    const singleOptionSelector = $("body.template-product").find(".single-option-selector");

    const tabs          = $(".js-product-tabs");
    const imgSlider     = $(".js-product-slick-slider");
    const navSlider     = $(".js-product-slick-slider-nav");
    const relatedSlider = $(".js-related-products");

    const KKOptionChnage = function() {
        singleOptionSelector.on('change',function(){
            var $variant = getVariantFromOptions();

            if( $variant ) {
                variantSelector.val( $variant.id );
              	updateSKU( $variant );
                updatePrice( $variant );
                updateComparePrice( $variant );
                updateAddToCart( $variant );
            }
        });
    };

    const getVariantFromOptions = function() {
        var selectedValues = getCurrentOption();
        var variants       = productJSON.variants;

        var found = _.find(variants, function(variant) {
            return selectedValues.every(function(values) {
                return _.isEqual(variant[values.index], values.value);
            });
        });

        return found;
    };

    const getCurrentOption = function() {
        var currentOptions = _.map( singleOptionSelector, function( $ele ) {
            var $element = $($ele);
            var type = $element.attr("type");
            var currentOption = {};

            if (type === 'radio' || type === 'checkbox') {
                if ($element[0].checked) {
                    currentOption.value = $element.val();
                    currentOption.index = $element.data('index');

                    return currentOption;
                } else {
                    return false;
                }
            } else {
                currentOption.value = $element.val();
                currentOption.index = $element.data('index');

                return currentOption;
            }
        });

        currentOptions = _.compact(currentOptions);
        return currentOptions;
    };
  
    const updateSKU = function( $variant ) {
        const skuHolder = $("#js-quickview-container").find(".js-product-sku");
        const sku       = $variant.sku ? $variant.sku : 'null';
        skuHolder.html( sku );
    };  

    const updatePrice = function( $variant ) {
        const priceHolder = $("body.template-product").find(".js-product-price");
        priceHolder.html( Shopify.formatMoney( $variant.price, kktheme.moneyFormat ) );
        KKUIs.updateCurrencies();
    };

    const updateComparePrice = function( $variant ) {
        const priceHolder = $("body.template-product").find(".js-product-compare-price");

        if( $variant.compare_at_price > $variant.price ) {
            priceHolder.removeClass("hidden");
            priceHolder.html( Shopify.formatMoney( $variant.compare_at_price, kktheme.moneyFormat ) );
        } else {
            priceHolder.addClass("hidden");
            priceHolder.html('');
        }
        KKUIs.updateCurrencies();
    };

    const updateAddToCart = function( $variant ) {
        const $btn         = $("body.template-product").find(".js-product-add-to-cart-btn");
        const $shopify_btn = $("body.template-product").find(".js-product-shopify-payment-btn");
        const $labl        = $("body.template-product").find(".js-product-btn-label");

        if( $variant.available ) {
            $btn.attr("disabled",false);
            $labl.html( kktheme.strings.addToCart );
            $shopify_btn.removeClass("hidden");
        } else {
            $btn.attr("disabled",true);
            $labl.html( kktheme.strings.soldOut );
            $shopify_btn.addClass("hidden");
        }
    };

    const KKAjaxCart = function() {
        const $btn = $("body.template-product").find(".js-product-add-to-cart-btn");

        if( $btn.hasClass("js-product-ajax-add-to-cart-btn") ) {
            $btn.on("click",function(e){
                e.preventDefault();
                $.ajax({
                    url: '/cart/add.js',
                    dataType: 'json',
                    type: 'post',
                    data: $btn.parents("form").serialize(),
                    beforeSend(xhr){
                        $btn.find("span.js-product-btn-label").addClass("hidden");

                        setTimeout(function(){
                            $btn.find("span.js-loading").removeClass("hidden");
                        }, 100 );

                    },
                    success: function(result,status,xhr) {
                        $btn.find("span.js-loading").addClass("hidden");

                        KKUIs.updateCartItemCount();

                        setTimeout(function(){
                            $btn.find("span.js-added").removeClass("hidden");
                        }, 1000 );

                        setTimeout(function(){
                            $btn.find("span.js-product-btn-label").removeClass("hidden");
                            $btn.find("span.js-added").addClass("hidden");
                        }, 2000 );
                    },
                    error: function( xhr, status, error) {
                        setTimeout(function(){
                            $btn.find("span.js-error").removeClass("hidden");
                        }, 500 );
                    }
                });
            });
        }
    };

    const KKProductSlider = function() {
        var $slider_type = imgSlider.attr('data-slider-type');
        var $flag = false;

        if( $slider_type == 'vertical' ) {
            $flag = true;
        }
      
        if( imgSlider.length ) {
            imgSlider.not('.slick-initialized').slick({
                slidesToShow: 1,
                adaptiveHeight: true,
                fade: false,
                arrows: false,
                asNavFor: navSlider,
                vertical: $flag,
                verticalSwiping: $flag,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: false,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]              
            });
            // When window resize...
            $(window).on('resize orientationChange', function(event) {
                imgSlider[0].slick.refresh();
            });
        }

        if( navSlider.length ) {
            navSlider.not('.slick-initialized').slick({
                infinite: false,
                slidesToShow: 7,
                adaptiveHeight: true,
                fade: false,
                slidesToScroll: 1,
                focusOnSelect: true,
                asNavFor: imgSlider,
                vertical: $flag,
                verticalSwiping: $flag,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                            infinite: false,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    }
                ]              
            });
            // When window resize...
            $(window).on('resize orientationChange', function(event) {
                navSlider[0].slick.refresh();
            });          
        }
    };

    const KKProductTabs = function(){
        if( tabs.length ) {
            const tabNavContainer     = tabs.find(".js-product-tabs-nav");
            const tabNav              = tabs.find(".js-product-tabs-nav .tab-menu-item");
            const tabContentContainer = tabs.find(".js-product-tabs-content");
            const tabContent          = tabs.find(".js-product-tabs-content .tab");

            tabNav.first().addClass("active");
            tabContent.first().addClass("active");

            tabNav.on("click",function(){
                const $this = $(this);
                const $id   = "." + $this.attr("id");

                tabNavContainer.find(".tab-menu-item.active").removeClass("active");
                $this.addClass("active");

                tabContentContainer.find(".tab.active").removeClass("active");
                tabContentContainer.find( $id ).addClass("active");
            });
        }
    };

    const KKProductReviewTab = function(){
        if( $('.template-product .spr-summary-starrating a.underlined-link').length ) {          
            const reviewLink = $(".template-product .spr-summary-starrating a.underlined-link");
            reviewLink.on("click",function(){
                $('.js-product-tabs-nav #tab-review-tab').trigger('click');

                var el = document.querySelector('.tab-review-tab #shopify-product-reviews');
                el && el.scrollIntoView();
                return false;
            });
        }
    };
  
    const KKRelatedProductsSlider = function( sliderWrp ){

        if( sliderWrp.length > 0 ) {
            sliderWrp.find(".row").not('.slick-initialized').slick({
                infinite: true,
                slidesToScroll: 1,
                slidesToShow:3,
                fade: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            infinite: true,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }
    };

    const KKProductRecommendations = function( recWrp ) {
        if( recWrp.length ) {
            const productId = recWrp.data().productId;
            const baseUrl   = recWrp.data().baseUrl;
            const recommendationsSectionUrl = baseUrl + '?section_id=product-recommendations&product_id=' + productId + '&limit=4';

            fetch(recommendationsSectionUrl)
                .then(function(response) {
                    return response.text();
                })
                .then(function(productHtml) {
                    if (productHtml.trim() === '') return;
                    container.innerHTML = productHtml;
                    container.innerHTML = container.firstElementChild.innerHTML;
                });
        }
    };

    return {
        init: function() {

            KKProductPage.KKOptionChnage();
            KKProductPage.KKAjaxCart();

            KKProductPage.KKProductSlider();
            KKProductPage.KKProductTabs();
            KKProductPage.KKProductReviewTab();
            KKProductPage.KKRelatedProductsSlider( relatedSlider );
            KKProductPage.KKProductRecommendations(  $(".js-product-recommendation") );
        },

        KKOptionChnage:KKOptionChnage,
        KKAjaxCart:KKAjaxCart,

        KKProductSlider:KKProductSlider,
        KKProductTabs:KKProductTabs,
        KKProductReviewTab:KKProductReviewTab,
        KKRelatedProductsSlider:KKRelatedProductsSlider,
        KKProductRecommendations:KKProductRecommendations
    };
})();

/**
 * Template: Collection
 */
var KKCollectionPage = (function(){
    const KKInitView = function(){
        $(document).ready(function(){
            var col = $.cookie( 'collectionColView' );
            if( col != null ) {
                var css_class = "js-col col-md-4 col-sm-12 col-xs-6";
              
                if( col == 2 ) {
                    css_class = "js-col col-md-6 col-sm-12 col-xs-6";
                } else if( col == 3 ) {
                    css_class = "js-col col-md-4 col-sm-12 col-xs-6";
                } else if( col == 4 ) {
                    css_class = "js-col col-md-3 col-sm-12 col-xs-6";
                }
    
                $(".js-product-listings-row").find(".js-col").removeClass().addClass( css_class );
                $('.view-controller').find(".active").removeClass("active");
                $(".js-collection-col-view.btn-view-" + col).addClass('active');
            } else {
                $(".js-collection-col-view.btn-view-3").addClass('active');
            }
        });
    };
  
    const KKSorting = function(){
        $(document).on("change", "#SortBy", function(){
            KKUtils.queryParams.sort_by = $(this).val();
            location.search = jQuery.param(KKUtils.queryParams);
        });
    };

    const KKGridView = function() {
        $(".js-collection-col-view").on("click",function(){
            var item   = $(this),
                parent = item.parent(".view-controller"),
                col    = item.attr("data-col");

            parent.find(".active").removeClass("active");
            item.addClass("active");

            var css_class = "js-col col-md-6 col-sm-12 col-xs-6";

            if( col == 2 ) {
                css_class = "js-col col-md-6 col-sm-12 col-xs-6";
            } else if( col == 3 ) {
                css_class = "js-col col-md-4 col-sm-12 col-xs-6";
            } else if( col == 4 ) {
                css_class = "js-col col-md-3 col-sm-12 col-xs-6";
            }

            $(".js-product-listings-row").find(".js-col").removeClass().addClass( css_class );

            $.cookie("collectionColView", col, {
              expires: 1,
              path: "/"
            });
        });
    };

    const KKPriceRange = function(){
        var sliderRange = $("#js-slider-range");
        var min         = 0;
        var max         = 0;

        if( sliderRange.length > 0 ) {
            var products =  $(".js-product-listings-row").find(".kk-product-card");

            products.each(function(){
                var price =  eval( $(this).data('product-price') );
                if( price > max ) {
                    max = price;
                }

                if( min == 0 ) {
                    min = price;
                }  else if( price < min ) {
                    min =  price;
                }
            });

            sliderRange.slider({
                range: true,
                min: min,
                max: max,
                values: [ min, max ],
                slide: function(event,ui){
                    sliderRange.next("#js-range-amount").find("#js-range-min").html( Shopify.formatMoney( ui.values[0], kktheme.moneyFormat ) );
                    sliderRange.next("#js-range-amount").find("#js-range-max").html( Shopify.formatMoney( ui.values[1], kktheme.moneyFormat ) );

                    products.each(function(){
                        var price = eval( $(this).data('product-price') );
                        if( price >= ui.values[0] && price <= ui.values[1]) {
                            $(this).parent().fadeIn();
                        }else{
                            $(this).parent().fadeOut();
                        }
                    });

                    KKUIs.updateCurrencies();
                }
            });

            sliderRange.next("#js-range-amount").find("#js-range-min").html( Shopify.formatMoney( min, kktheme.moneyFormat ) );
            sliderRange.next("#js-range-amount").find("#js-range-max").html( Shopify.formatMoney( max, kktheme.moneyFormat ) );
            KKUIs.updateCurrencies();
        }
    };

    return {
        init: function() {
            KKCollectionPage.KKInitView();
            KKCollectionPage.KKSorting();
            KKCollectionPage.KKGridView();
            KKCollectionPage.KKPriceRange();
        },
        KKInitView:KKInitView,
        KKSorting:KKSorting,
        KKGridView:KKGridView,
        KKPriceRange:KKPriceRange
    };
})();

/**
 * Module: WishList
 */
var KKWishList = (function(){
    const wishlistPageContainer = $("#js-page-wishlist");
    const wishlistBtnSelector   = ".js-btn-wishlist";
    let   wishlistArray         = localStorage.getItem('kkLocalWishlist') ? JSON.parse( localStorage.getItem('kkLocalWishlist') ) : [];

    const noResult = function() {
        if( wishlistPageContainer.length ) {
            const source   = $("#wishlistNoResult").html();
            const template = Handlebars.compile(source);
            const context  = { title:kktheme.strings.wishlistTitle, body:kktheme.strings.wishlistNoResult };
            const html     = template( context );

            wishlistPageContainer.html( html );
        }
    };

    const hasResult = function( wishlistArray ) {
        if( wishlistPageContainer.length ) {
            var items = [];
            wishlistArray.forEach(function( handle ){
                var productObj       = KKUtils.getProductObjByHandle( handle );
                var compare_at_price = parseFloat( productObj.compare_at_price );
                var price            = parseFloat( productObj.price );
                var is_gr_compare_at_price = false;

                if( compare_at_price > price ) {
                    is_gr_compare_at_price = true;
                }

                items.push({
                    id: productObj.id,
                    handle: handle,
                    title: productObj.title,
                    url: productObj.url,
                    available: productObj.available,
                    price: productObj.price,
                    formatedPrice: Shopify.formatMoney( productObj.price, kktheme.moneyFormat ),
                    compare_at_price: productObj.compare_at_price,
                    formatedComparePrice: Shopify.formatMoney( productObj.compare_at_price, kktheme.moneyFormat ),
                    is_gr_compare_at_price: is_gr_compare_at_price,
                    price_varies: productObj.price_varies,
                    featured_image: productObj.featured_image
                } );
            });

            const source   = $("#wishlistResult").html();
            const template = Handlebars.compile(source);
            const context  = {
                title: kktheme.strings.wishlistTitle,
                items: items
            };
            const html     = template( context );
            wishlistPageContainer.html( html );
            KKUIs.updateCurrencies();
        }
    };

    const addToWishList = function() {
        $('body').on("click", wishlistBtnSelector, function(){
            var $this   = $(this),
                $handle = $this.attr("data-wishlist-handle");
                $found  = wishlistArray.indexOf( $handle );

            if( !$this.hasClass("wishlist-added") ) {
                $this.addClass("wishlist-added");
                $this.find('span.btn-text').text('Added to Wishlist');
                wishlistArray.push( $handle );
                localStorage.setItem('kkLocalWishlist', JSON.stringify( wishlistArray ) );
            } else {
                $this.removeClass("wishlist-added");
                $this.find('span.btn-text').text('Add to Wishlist');
                wishlistArray.splice( $found, 1 );
                localStorage.setItem('kkLocalWishlist', JSON.stringify( wishlistArray ) );
            }

            /**
             * Updating Wishlist Page
             */
                var updateWishlistArr = JSON.parse( localStorage.getItem('kkLocalWishlist') );
                if( updateWishlistArr.length > 0 ) {
                    hasResult( updateWishlistArr );
                } else {
                    noResult();
                }
        });
    };

    const loadWishlistClass = function() {
        wishlistArray.forEach(function(handle){
            var $item = $('[data-wishlist-handle="'+ handle +'"]');

            if( $item.length ) {
                $item.addClass("wishlist-added");
                $item.find('span.btn-text').text('Added to Wishlist');
            }
        });
    };

    return {
        init: function() {
            if ( typeof ( Storage ) !== 'undefined' ) {
                    if( wishlistArray.length > 0 ) {
                    loadWishlistClass();
                    hasResult( wishlistArray );
                } else {
                    noResult();
                }
            } else {
                alert("Sorry ! No Web Storage Support");
            }

            addToWishList();
        },
        loadWishlistClass:loadWishlistClass
    };
})();

/**
 * Module: QuickView
 */
var KKQuickView = (function(){

    /**
     * imgSlider: product slider images
     * navSlider: product nav slider images
     */
    const productSlider = function( imgSlider, navSlider ){

        if( imgSlider.length ) {
            imgSlider.not('.slick-initialized').slick({
                slidesToShow: 1,
                adaptiveHeight: true,
                fade: false,
                arrows: false,
                asNavFor: navSlider
            });
        }

        if( navSlider.length ) {
            navSlider.not('.slick-initialized').slick({
                infinite: true,
                slidesToShow: 7,
                adaptiveHeight: true,
                fade: false,
                slidesToScroll: 1,
                focusOnSelect: true,
                asNavFor: imgSlider
            });
        }
    };

    /**
     * variantSelector: product variant dropdown
     * singleOptionSelector: product individual option
     */
    const productOptionChange = function( variantSelector, singleOptionSelector ) {
        singleOptionSelector.on('change',function(){
            var $variant = KKQuickView.getVariantFromOptions( singleOptionSelector );
            if( $variant ) {
                variantSelector.val( $variant.id );
                KKQuickView.updatePrice( $variant );
                KKQuickView.updateComparePrice( $variant );
                KKQuickView.updateAddToCart( $variant );
            }
        });
    };

    const getVariantFromOptions = function( singleOptionSelector ) {
        const productJSON = kktheme.quickvew_product;
        var selectedValues = KKQuickView.getCurrentOption( singleOptionSelector );
        var variants       = productJSON.variants;

        var found = _.find(variants, function(variant) {
            return selectedValues.every(function(values) {
                return _.isEqual(variant[values.index], values.value);
            });
        });

        return found;
    };

    const getCurrentOption = function( singleOptionSelector ) {
        var currentOptions = _.map( singleOptionSelector, function( $ele ) {
            var $element = $($ele);
            var type = $element.attr("type");
            var currentOption = {};

            if (type === 'radio' || type === 'checkbox') {
                if ($element[0].checked) {
                    currentOption.value = $element.val();
                    currentOption.index = $element.data('index');

                    return currentOption;
                } else {
                    return false;
                }
            } else {
                currentOption.value = $element.val();
                currentOption.index = $element.data('index');

                return currentOption;
            }
        });

        currentOptions = _.compact(currentOptions);
        return currentOptions;
    };

    const updatePrice = function( $variant ) {
        const priceHolder = $("#js-quickview-container").find(".js-product-price");
        priceHolder.html( Shopify.formatMoney( $variant.price, kktheme.moneyFormat ) );
        KKUIs.updateCurrencies();
    };

    const updateComparePrice = function( $variant ) {
        const priceHolder = $("#js-quickview-container").find(".js-product-compare-price");

        if( $variant.compare_at_price > $variant.price ) {
            priceHolder.removeClass("hidden");
            priceHolder.html( Shopify.formatMoney( $variant.compare_at_price, kktheme.moneyFormat ) );
        } else {
            priceHolder.addClass("hidden");
            priceHolder.html('');
        }
        KKUIs.updateCurrencies();
    };

    const updateAddToCart = function( $variant ) {
        const $btn         = $("#js-quickview-container").find(".js-product-add-to-cart-btn");
        const $shopify_btn = $("#js-quickview-container").find(".js-product-shopify-payment-btn");
        const $labl        = $("#js-quickview-container").find(".js-product-btn-label");

        if( $variant.available ) {
            $btn.attr("disabled",false);
            $labl.html( kktheme.strings.addToCart );
            $shopify_btn.removeClass("hidden");
        } else {
            $btn.attr("disabled",true);
            $labl.html( kktheme.strings.soldOut );
            $shopify_btn.addClass("hidden");
        }
    };

    const ajaxCart = function( $btn ) {
        if( $btn.hasClass("js-product-ajax-add-to-cart-btn") ) {
            $btn.on("click",function(e){
                e.preventDefault();
                $.ajax({
                    url: '/cart/add.js',
                    dataType: 'json',
                    type: 'post',
                    data: $btn.parents("form").serialize(),
                    beforeSend(xhr){
                        $btn.find("span.js-product-btn-label").addClass("hidden");

                        setTimeout(function(){
                            $btn.find("span.js-loading").removeClass("hidden");
                        }, 100 );

                    },
                    success: function(result,status,xhr) {
                        $btn.find("span.js-loading").addClass("hidden");

                        KKUIs.updateCartItemCount();

                        setTimeout(function(){
                            $btn.find("span.js-added").removeClass("hidden");
                        }, 1000 );

                        setTimeout(function(){
                            $btn.find("span.js-product-btn-label").removeClass("hidden");
                            $btn.find("span.js-added").addClass("hidden");
                        }, 2000 );
                    },
                    error: function( xhr, status, error) {
                        setTimeout(function(){
                            $btn.find("span.js-error").removeClass("hidden");
                        }, 500 );
                    }
                });
            });
        }
    };

    const initQuickView = function() {
        $('body').on("click", ".js-btn-quickview", function(){
            const handler = $(this).attr("data-quick-view-handle");
            $.ajax({
                type: "get",
                url:'/products/' + handler + '?view=quickview',
                beforeSend: function() {},
                complete: function( $res ) {
                    $(".js-quickview-modal").removeClass("hidden");
                    $(".js-quickview-modal").find(".modal-body").html( $res.responseText );

                    KKUIs.updateCurrencies();

                    KKQuickView.productOptionChange( $(".js-quickview-modal").find("#ProductSelect"), $(".js-quickview-modal").find(".single-option-selector"), );
                    KKQuickView.productSlider( $(".js-quickview-modal").find(".js-product-slick-slider"), $(".js-quickview-modal").find(".js-product-slick-slider-nav") );

                    KKQuickView.ajaxCart( $("#js-quickview-container").find(".js-product-add-to-cart-btn") );
                },
                error: function( $res ) {}
            });
        });
    };

    const closeModal    = function() {
        $("body").on("click", ".js-quickview-modal-close", function(){
            $(".js-quickview-modal").addClass("hidden");
            $(".js-quickview-modal").find(".modal-body").html("");
        });
    };

    return {
        init: function(){
            initQuickView();
            closeModal();
        },
        productSlider:productSlider,

        productOptionChange:productOptionChange,
        getVariantFromOptions:getVariantFromOptions,
        getCurrentOption:getCurrentOption,
        updatePrice:updatePrice,
        updateComparePrice:updateComparePrice,
        updateAddToCart:updateAddToCart,
        ajaxCart:ajaxCart
    };
})();

/**
 * Module: Compare
 */
var KKCompare = (function(){
    let compareArray  = localStorage.getItem('kkLocalCompare') ? JSON.parse( localStorage.getItem('kkLocalCompare') ) : [];

    const compareBtnSelector = ".js-btn-compare";
    const countSelector      = '.js-compare-count';
    const countWrap          = '.js-compare-link';

    const addToCompare = function() {
        $('body').on("click", compareBtnSelector, function(){
            var $this   = $(this),
                $handle = $this.attr("data-compare-handle"),
                $found  = compareArray.indexOf( $handle ),
                $action = '';

            if( !$this.hasClass("compare-added") ) {
                $this.addClass("compare-added");
                $this.find('span.btn-text').text('Added to Compare');
                compareArray.push( $handle );
                localStorage.setItem('kkLocalCompare', JSON.stringify( compareArray ) );
                $action = 'add';
                setTimeout(function(){
                    $(".js-compare-modal").removeClass("hidden");
                }, 1000);
            } else {
                $this.removeClass("compare-added");
                $this.find('span.btn-text').text('Compare');                
                compareArray.splice( $found, 1 );
                localStorage.setItem('kkLocalCompare', JSON.stringify( compareArray ) );
                $action = 'remove';
            }

            /**
             * Update Bottom Compare Icon
             */
            var updateCompateArr = JSON.parse( localStorage.getItem('kkLocalCompare') );
            compareIcon( updateCompateArr );

            /**
             * Update Compare Table
             */
            updateCompateTable( $handle, $action );
        });
    };

    const compareIcon = function( compareArray ){
        var count = Math.ceil( compareArray.length );
        $(countSelector).html( count );
        if( count >= 2 ) {
            $(countSelector).addClass("js-visible");
        } else {
            $(countSelector).removeClass("js-visible");
        }
    };

    const hasResult = function( compareArray ) {
        compareArray.forEach(function( handle ){
            updateCompateTable( handle, 'add' );
        });
    };

    const updateCompateTable = function( $handle, $action ) {
        const $info         = $("ul.js-compare-product-info");
        const $price        = $("ul.js-compare-product-price");
        const $rating       = $("ul.js-compare-product-rating");
        const $sku          = $("ul.js-compare-product-sku");
        const $desc         = $("ul.js-compare-product-desc");
        const $collection   = $("ul.js-compare-product-collection");
        const $availability = $("ul.js-compare-product-availability");
        const $ptype        = $("ul.js-compare-product-ptype");
        const $vendor       = $("ul.js-compare-product-vendor");

        if( $action == 'add' ) {
            var $productObj = KKUtils.getProductObjByHandle( $handle );
            var $variants   = $productObj.variants;

            // Info
                const info_source   = $("#compare-product-info").html();
                const info_template = Handlebars.compile( info_source );
                const info_html     = info_template({
                    handle:$productObj.id,
                    title:$productObj.title,
                    url:$productObj.url,
                    image:$productObj.featured_image
                });
                $info.find('li.no-product-title').remove();
                $info.append( info_html );

            // Pricing
                var compare_at_price       = parseFloat( $productObj.compare_at_price );
                var price                  = parseFloat( $productObj.price );
                var is_gr_compare_at_price = false;

                if( isNaN( compare_at_price ) ) {
                    compare_at_price = 0;
                }

                if( compare_at_price > price ) {
                    is_gr_compare_at_price = true;
                }

                const price_source   = $("#compare-product-price").html();
                const price_template = Handlebars.compile( price_source );
                const price_html     = price_template({
                    handle: $productObj.id,
                    available: $productObj.available,
                    price: $productObj.price,
                    formatedPrice: Shopify.formatMoney( $productObj.price, kktheme.moneyFormat ),
                    compare_at_price: compare_at_price,
                    formatedComparePrice: Shopify.formatMoney( $productObj.compare_at_price, kktheme.moneyFormat ),
                    is_gr_compare_at_price: is_gr_compare_at_price,
                    price_varies: $productObj.price_varies,
                });
                $price.append( price_html );
                KKUIs.updateCurrencies();

            // Rating
            if( $rating.length ) {
                const rating_source   = $("#compare-product-rating").html();
                const rating_template = Handlebars.compile(rating_source);
                const rating_html     = rating_template({ handle:$productObj.id });
                $rating.append( rating_html );
            }

            // SKU
            if( $sku.length ) {
                const sku_source   = $("#compare-product-sku").html();
                const sku_template = Handlebars.compile(sku_source);
                let   $sku_value   = '-';

                $.each( $variants, function( key, value ){
                    let l_sku = value.sku;
                    if( l_sku != '' ) {
                        $sku_value = l_sku;
                        return false;
                    }
                });

                const sku_html     = sku_template({ handle:$productObj.id, sku: $sku_value });
                $sku.append( sku_html );
            }

            // Availability
            if( $availability.length ) {
                const availability_source   = $("#compare-product-availability").html();
                const availability_template = Handlebars.compile(availability_source);
                const availability_html     = availability_template({ handle:$productObj.id, available: $productObj.available });
                $availability.append( availability_html );
            }

            // Product Types
            if( $ptype.length ) {
                var   ptype        = $productObj.type || '-';
                const ptype_source   = $("#compare-product-ptype").html();
                const ptype_template = Handlebars.compile(ptype_source);
                const ptype_html     = ptype_template({ handle:$productObj.id, ptype: ptype });

                $ptype.append( ptype_html );
            }

            // Vendor
            if( $vendor.length ) {
                const vendor_source   = $("#compare-product-vendor").html();
                const vendor_template = Handlebars.compile(vendor_source);
                const vendor_html     = vendor_template({ handle:$productObj.id, vendor:$productObj.vendor });

                $vendor.append( vendor_html );
            }
        } else if( $action == 'remove' ) {
            var $productObj = KKUtils.getProductObjByHandle( $handle );
            var handle_id   = $productObj.id;

            $info.find('li[data-compare-handle="'+handle_id+'"]').remove();
            $price.find('li[data-compare-handle="'+handle_id+'"]').remove();
            $rating.find('li[data-compare-handle="'+handle_id+'"]').remove();
            $sku.find('li[data-compare-handle="'+handle_id+'"]').remove();
            $desc.find('li[data-compare-handle="'+handle_id+'"]').remove();
            $collection.find('li[data-compare-handle="'+handle_id+'"]').remove();
            $availability.find('li[data-compare-handle="'+handle_id+'"]').remove();
            $ptype.find('li[data-compare-handle="'+handle_id+'"]').remove();
            $vendor.find('li[data-compare-handle="'+handle_id+'"]').remove();
        }
    };

    const loadCompareClass = function() {
        compareArray.forEach(function(handle){
            var $item = $('[data-compare-handle="'+ handle +'"]');

            if( $item.length ) {
                $item.addClass("compare-added");
                $item.find('span.btn-text').text('Added to Compare');
            }
        });
    };

    const removeAll = function() {
        $('body').on("click", ".compare-remove-all", function(){
            compareArray.forEach(function(handle){
                var $item = $('[data-compare-handle="'+ handle +'"]');

                if( $item.length ) {
                    $item.removeClass("compare-added");
                    $item.find('span.btn-text').text('Compare');
                }
            });

            compareArray.length = 0;
            localStorage.setItem('kkLocalCompare', JSON.stringify( compareArray ) );
            $("ul.modal-body-data").html("");
            $(countSelector).html("").removeClass("js-visible");
            $("ul.modal-body-data.js-compare-product-info").html('<li class="no-product-title"><h5>No Products Found.</h5></li>');
            setTimeout(function(){
                $(".js-compare-modal").addClass("hidden");
            }, 1000 );
        });
    };

    const closeModal = function() {
        $("body").on("click", ".js-compare-close-link", function(){
            $(".js-compare-modal").addClass("hidden");
        });
    };

    const openModal = function(){
        $("body").on("click", countWrap, function(){
            $(".js-compare-modal").removeClass("hidden");
        });
    };

    return {
        init: function(){
            if ( typeof ( Storage ) !== 'undefined' ) {
                if( compareArray.length > 0 ) {
                    loadCompareClass();
                    compareIcon( compareArray );
                    hasResult( compareArray );
                }

                addToCompare();
                removeAll();

                closeModal();
                openModal();
            } else {
                alert("Sorry ! No Web Storage Support");
            }
        },
        loadCompareClass:loadCompareClass
    };
})();

/**
 * Init
 */
KKUIs.init();
KKImageCarousel.init();
KKSlider1Carousel.init();
KKFeaturedProductCarousel.init();
KKTestimonial1Carousel.init();
KKTestimonial2Carousel.init();
KKVideoPopup.init();
KKCustomElements.init();
KKInstagrm.init();

KKProductPage.init();
KKCollectionPage.init();

KKWishList.init();
KKQuickView.init();
KKCompare.init();

$(document).on('shopify:section:load', function(e){
    $el = $( e.target );
  
    /**
     * Section: Slideshow
     */
    if( $el.hasClass("js-section-slider") ) {
        const carousel = $el.find(".js-section-slideshow");
        if( carousel.length ) {
            carousel.each(function(){
                KKSlider1Carousel.kkSlick( $(this) );
            });
        }
    }  

    /**
     * Section: Image carousel
     */
    if( $el.hasClass("js-section-image-carousel") ) {
        const carousel = $el.find(".js-slick-carousel");
        if( carousel.length ) {
            carousel.each(function(){
                KKImageCarousel.kkSlick( $(this) );
            });
        }
    }

    /**
     * Section: Testimonial 1
     */
    if( $el.hasClass("js-section-testimonial-1-carousel") ) {
        const carousel = $el.find(".js-slick-carousel");
        if( carousel.length ) {
            carousel.each(function(){
                KKTestimonial1Carousel.kkSlick( $(this) );
            });
        }
    }

    /**
     * Section: Testimonial 2
     */
    if( $el.hasClass("js-section-testimonial-2-carousel") ) {
        const carousel = $el.find(".js-slick-carousel");
        if( carousel.length ) {
            carousel.each(function(){
                KKTestimonial2Carousel.kkSlick( $(this) );
            });
        }
    }

    /**
     * Section: Video Popup
     */
    if( $el.hasClass("js-section-video-popup") ) {
        if( $el.length ) {
            $el.each(function(){
                KKVideoPopup.kkModal( $(this) );
            });
        }
    }

    /**
     * Section: Product Page : Top Section
     */
    if( $el.hasClass("js-product-top-section") ) {
        if( $el.length ) {
            $el.each(function(){
                KKProductPage.KKProductSlider();
            });
        }
    }

    /**
     * Section: Product Recommendations
     */
    if( $el.hasClass("js-product-recommendations-section") ) {
        if( $el.length ) {
            $el.each(function(){
                if( $el.find(".js-related-products").length ) {
                    KKProductPage.KKRelatedProductsSlider( $el.find(".js-related-products") );
                } else {
                    KKProductPage.KKProductRecommendations( $el.find(".js-product-recommendation") );
                }
            });
        }
    }

    /**
     * Section: Instagram
     */
    if( $el.hasClass("js-section-instagram") ) {
        if( $el.length ) {
            $el.each(function(){
                KKInstagrm.show();
            });
        }
    }
});

$(document).on('shopify:section:unload', function(e){
});

$(document).on('shopify:section:select', function(e){
});

$(document).on('shopify:section:deselect', function(e){
});

/* Keep the homepage slider aligned while the viewport is resized */
(function () {
  var sliderResizeFrame;

  window.addEventListener('resize', function () {
    window.cancelAnimationFrame(sliderResizeFrame);

    sliderResizeFrame = window.requestAnimationFrame(function () {
      if (!window.jQuery || !window.jQuery.fn.slick) return;

      window.jQuery(
        '.js-section-slideshow.slick-initialized'
      ).slick('setPosition');
    });
  });
})();